/*
 *
 * AmlPopupConfirm
 *
 * @version 1.0.0
 * @author Elia Minozzi
 * @since 23-Jul-2025
*/

import React from 'react'
import PortalMessage from 'Utility/PortalMessage'

const formattedMessage = {
  controlAndSave: (
    <PortalMessage
      id='t.app.aml.amlModalConfirm.controlAndSave'
      defaultMessage='Controlla e salva i tuoi dati'
    />
  ),
  verifyInfo: (
    <PortalMessage
      id='t.app.aml.amlModalConfirm.verifyInfo'
      defaultMessage='Verifica le informazioni'
    />
  ),
  subtitle: (
    <PortalMessage
      id='t.app.aml.amlModalConfirm.subtitle'
      defaultMessage='Prima di procedere al salvataggio puoi controllare che le informazioni fornite siano corrette scaricando un documento contenente tutti i dati da te inseriti.'
    />
  ),
  download: (
    <PortalMessage
      id='t.app.aml.amlModalConfirm.download'
      defaultMessage='scarica documento'
    />
  ),
  save: (
    <PortalMessage
      id='t.app.save'
      defaultMessage='Salva'
    />
  ),
  cancel: (
    <PortalMessage
      id='t.app.cancel'
      defaultMessage='Annulla'
    />
  )
}

export default formattedMessage
